import styled from 'styled-components';
import { whiteColor, primaryColor } from '@app/styles';

export const RadioButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  margin-top: -4px;
  margin-bottom: 15px;
`;
export const Item = styled.div`
  display: flex;
  align-items: center;
  height: 28px;
  margin-top: 0;
  position: relative;
`;
export const RadioButtonLabel = styled.label`
  position: absolute;
  border-radius: 50%;
  background: white;
  opacity: 0;
`;
export const RadioButtonComponent = styled.input`
  opacity: 1;
  z-index: 1;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-right: 15px;
  cursor: pointer;
  &:hover ~ ${RadioButtonLabel} {
    background: ${whiteColor};
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      background: ${primaryColor};
    }
  }
  ${props =>
    props.checked &&
    ` 
    &:checked + ${RadioButtonLabel} {
      background: ${whiteColor};
      border: 1px solid ${primaryColor};
      &::after {
        content: "";
        display: block;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        margin: 6px;
        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.1);
        background: ${primaryColor};
      }
    }
  `}
`;

export const RadioButton = styled.input`
  width: 20px;
  height: 20px;
  margin: 6px;
`;

export const Label = styled.div`
  // margin-left: 8px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
`;
